import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { t } from 'i18next';
import { screen } from '../../common/breakpoints';
import { Heading, Spacing } from '../../common/spacings';

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  padding: ${Spacing.XL};
  font-size: ${Heading.XS};

  @media screen and ${screen.m} { {
    font-size: ${Heading.S};
  }

`;

export const Welcome = (): ReactElement => {
  return (
    <StyledContainer data-testid="welcome-container">
      <h2>{t('header.greetings')}</h2>
    </StyledContainer>
  );
};
